import React from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface SearchBarProps extends React.InputHTMLAttributes<HTMLInputElement> {
    onClear?: () => void;
    containerClassName?: string;
}

export const SearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>(
    ({ className, containerClassName, value, onChange, onClear, placeholder = "Search...", ...props }, ref) => {
        const hasValue = value && String(value).length > 0;

        return (
            <div className={cn("relative w-full max-w-sm", containerClassName)}>
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                    ref={ref}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className={cn(
                        "pl-10 pr-10 rounded-[12px] bg-[#F5F7F9] border-0 text-xs sm:text-sm h-9 sm:h-10 focus-visible:ring-1 focus-visible:ring-primary shadow-none",
                        className
                    )}
                    {...props}
                />
                {hasValue && onClear && (
                    <button
                        type="button"
                        onClick={onClear}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
                    >
                        <X className="h-4 w-4" />
                    </button>
                )}
            </div>
        );
    }
);

SearchBar.displayName = "SearchBar";
